export { default } from './ProductLink';